export var LegalStatusTypes;
(function (LegalStatusTypes) {
    LegalStatusTypes["LEGAL_STATUS"] = "LEGAL_STATUS";
    LegalStatusTypes["LEGAL_EVENT"] = "LEGAL_EVENT";
    LegalStatusTypes["SIMPLE_LEGAL_STATUS"] = "SIMPLE_LEGAL_STATUS";
})(LegalStatusTypes || (LegalStatusTypes = {}));
